import React, { useEffect, useState } from "react";
import { useApp } from "../../context/AppContext";
import { getUsersBySite } from "../../services/authService";

export default function UsersPage() {
  const { siteId } = useApp();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadUsers = async () => {
      if (!siteId) {
        setUsers([]);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError("");
        const response = await getUsersBySite(siteId);
        const items = response?.results || response?.data || response || [];
        setUsers(Array.isArray(items) ? items : []);
      } catch (err) {
        console.error(err);
        setError(err?.message || "Gagal memuat daftar user.");
      } finally {
        setLoading(false);
      }
    };

    loadUsers();
  }, [siteId]);

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Users</h1>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">Daftar user yang memiliki membership pada site aktif.</p>
      </div>

      {error ? <div className="mb-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700 dark:border-red-800 dark:bg-red-950/40 dark:text-red-300">{error}</div> : null}

      <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800">
        {loading ? <div className="p-6 text-sm text-gray-600 dark:text-gray-300">Memuat user...</div> : users.length === 0 ? <div className="p-6 text-sm text-gray-600 dark:text-gray-300">Belum ada user untuk site ini.</div> : (
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-50 dark:bg-gray-900">
                <tr>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700 dark:text-gray-200">Nama</th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700 dark:text-gray-200">Email</th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700 dark:text-gray-200">Role</th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700 dark:text-gray-200">Aktif</th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700 dark:text-gray-200">Dibuat</th>
                </tr>
              </thead>
              <tbody>
                {users.map((item) => (
                  <tr key={item.id} className="border-t border-gray-100 dark:border-gray-700">
                    <td className="px-4 py-3 text-gray-900 dark:text-white">{item.name || "-"}</td>
                    <td className="px-4 py-3 text-gray-600 dark:text-gray-300">{item.email || "-"}</td>
                    <td className="px-4 py-3 text-gray-600 dark:text-gray-300">{item.role || "-"}</td>
                    <td className="px-4 py-3 text-gray-600 dark:text-gray-300">{item.is_active ? "Ya" : "Tidak"}</td>
                    <td className="px-4 py-3 text-gray-600 dark:text-gray-300">{item.created_at || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
